import { render, staticRenderFns } from "./AuthRedirect.vue?vue&type=template&id=58d4de44&scoped=true&"
import script from "./AuthRedirect.vue?vue&type=script&lang=js&"
export * from "./AuthRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d4de44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58d4de44')) {
      api.createRecord('58d4de44', component.options)
    } else {
      api.reload('58d4de44', component.options)
    }
    module.hot.accept("./AuthRedirect.vue?vue&type=template&id=58d4de44&scoped=true&", function () {
      api.rerender('58d4de44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AuthRedirect.vue"
export default component.exports